import { render } from "./CourseDetailsUpdate.vue?vue&type=template&id=73dd07f0&scoped=true"
import script from "./CourseDetailsUpdate.vue?vue&type=script&lang=js"
export * from "./CourseDetailsUpdate.vue?vue&type=script&lang=js"

import "./CourseDetailsUpdate.vue?vue&type=style&index=0&id=73dd07f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73dd07f0"]])

export default __exports__